//const message = {th:{},en:{}}
const message = {th:require('./asset/data/message-th.json'),en:require('./asset/data/message-en.json')}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

//const localStorageKey = 'langConfig';  
//const  lang = JSON.parse(localStorage.getItem(localStorageKey)) || {lang:'th'}
const lang = getCookie('bf_locale') || 'th';

let api = {

  getMessage(language = '') {
    //return content.filter(obj => obj.lang === language)[0];
    if(language==''){
      language = lang
    }
    return message[language];
  },
  getLocale(){
    return lang;
  }
};

module.exports = api;



// WEBPACK FOOTER //
// ./src/api.js